import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './config/firebaseConfig'; // Firebase 초기화

// 웹 폰트 로드
const loadFonts = () => {
  const fonts = [
    {
      family: 'Pretendard',
      weight: 400,
      url: '/fonts/Pretendard-Regular.woff2'
    },
    {
      family: 'Pretendard',
      weight: 700,
      url: '/fonts/Pretendard-Bold.woff2'
    },
    {
      family: 'Noto Sans KR',
      weight: 400,
      url: '/fonts/NotoSansKR-Regular.woff2'
    },
    {
      family: 'Noto Sans KR',
      weight: 700,
      url: '/fonts/NotoSansKR-Bold.woff2'
    }
  ];

  fonts.forEach(font => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'font';
    link.type = 'font/woff2';
    link.href = font.url;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
};

// 폰트 로드 후 앱 렌더링
loadFonts();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
